module.exports = __webpack_public_path__ + "img/web.499b6a44.png";